import './Footer.css';
import React from "react";

function Footer(props) {

    return (
        <div className="footer">
            {/* <div className="footerRow">
                <p onClick={() => props.setActiveTab("home")} className="footerText footerTextLarge "> Wild Roses Endometriosis Research Foundation</p>
                <p onClick={() => props.setActiveTab("about")} className="footerText footerTextSmall "> About </p>
            </div> */}
            <div className="footerLine"></div>
            {/* <div className="footerRow">
                <a className="footerText footerTextLink" href="https://cerise-technology.com/"> Copyright 2025 Cerise Technology LLC</a>
                <a className="footerText footerTextLink" href="https://cerise-technology.com/terms"> Terms </a>
                <a className="footerText footerTextLink" href="https://cerise-technology.com/privacy"> Privacy</a>
            </div> */}
        </div>
    )
}

export default Footer;